export enum FilterBuilderInputMode {
  Text = "text",
  Number = "number",
  BetweenNumber = "between_number",
  BetweenCost = "between_cost",
  BetweenLatency = "between_latency",
  Date = "date",
  DateRange = "daterange",
  Cost = "cost",
  Latency = "latency",
  None = "none",
}

export enum FilterBuilderDateInputType {
  None = "none",
  Date = "date",
  DateRange = "daterange",
}

export type { Filter, FilterValue, OperatorDefinition, StructuredFilterRequest } from "./config";
